var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckpoint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#2FCBC2;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.5,18l2.8,8.7h3.1L27.6,18H24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.7,18l0.4,1.3l2.4,7.4h3.1L33.8,18H30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.4,18l2.8,8.7h3.1L21.4,18H18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.2,36.9c0-0.3-0.2-0.5-0.5-0.7v-9.2c0-0.1,0.1-0.3,0.3-0.3H18l-1.5-4.6l-1.2-3.9c-1,0-1.1,0.6-1.1,1.6v16.5 c-0.3,0.2-0.5,0.4-0.5,0.7C14.9,36.9,16.1,36.9,17.2,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.2,36.9C41.2,36.9,41.2,36.9,41.2,36.9c0-0.3-0.2-0.5-0.5-0.7V19.8c0-1-0.8-1.7-1.8-1.7h-2l0.4,1.3l1.1,3.4 v4.1c0,0,0,0.1,0,0.3v9.2c-0.3,0.2-0.5,0.4-0.5,0.7c0,0,0,0,0,0.1C39,36.9,40.1,36.9,41.2,36.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckpoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkpoint.ab877f6164cb2d5900aad3c179c79eb7.svg";